const dashboardAPIRoutes = {
  globalAdminDashboard: '/api/v1/subscription/global-admin-web-dashboard',
  registeredBabysitters: '/api/v1/admin/registered-babysitters',
  blockBabysitter: '/api/v1/admin/block-babysitter',
  approveBabysitter: '/api/v1/admin/approve-babysitter',
  registeredConsumersCount: '/api/v1/admin/registered-consumers-count',
  registeredConsumersForBabysitterId:
    '/api/v1/admin/registered-consumers-for-babysitterId',

  adminReplyToCloseTicket: '/api/v1/support/admin-reply-to-raised-tickets',
  imageUploadInGroupChat: '/api/v1/group/upload-img-inside-group-chat',
  subAdminListAll: '/api/v1/admin/sub-admin-list',
  participantSupervisor: '/api/v1/admin/participant-supervisor',
  changeParticipantSupervisor: '/api/v1/admin/change-participant-supervisor',
}

const registeredConsumers = {
  registerConsumers: '/api/v1/admin/registered-consumers',
  consumersDetails: '/api/v1/submission/consumer-details/',
  checkInCount: '/api/v1/submission/consumer-details/',
  manulfaceAuthentication: '/api/v1/submission/manual-face-authentication/',
  blockConsumer: '/api/v1/admin/block-consumer',
}

const RandomCheckInsAPIRoutes = {
  fetchAdminRandomCheckIn: '/api/v1/submission/fetch-admin-random-checkIn',
  adminRandomCheckInButtonStatus:
    '/api/v1/submission/admin-random-checkin-button-status',
  adminImposedCheckIn: '/api/v1/submission/admin-imposed-checkin',
}

export const generalAPIRoutes = {
  ...dashboardAPIRoutes,
  ...registeredConsumers,
  ...RandomCheckInsAPIRoutes,
}
